import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getEnvVariables} from "../../helpers/getEnvVariables";
import {BuyOrderType} from "data/types";
const {REACT_APP_URL} = getEnvVariables();
export const eventsApi = createApi({
  reducerPath: "events",
  baseQuery: fetchBaseQuery({baseUrl: REACT_APP_URL}),
  endpoints: (builder) => ({
    getEvents: builder.query({
      query: (params?: Record<string, any>) => ({
        url: "event-global",
        params,
      }),
      keepUnusedDataFor: 600,
    }),
    getEvent: builder.query({
      query: (id) => ({
        url: `api/v2/event`,
        headers: new Headers({
          "Content-Type": "application/json",
          "Content-Length": "2000000",
        }),
        params: {id},
        timeout: 10000,
      }),
    }),
    getPhasesByEvent: builder.mutation({
      query: (data) => ({
        url: "locality/phase-current",
        method: "POST",
        body: data,
      }),
    }),
    getAdsByEvent: builder.query({
      query: (eventId) => `event/promotions/${eventId}`,
    }),
    getZonesByLocality: builder.query({
      query: (localityId) => `locality-zones/${localityId}`,
    }),
    deleteSeatsByLocality: builder.mutation({
      query: (localityId) => ({
        url: `locality-zone/cancel-locality-topics/${localityId}`,
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
      }),
    }),
    deleteSeatsByEvent: builder.mutation({
      query: (eventId) => ({
        url: `locality-zone/cancel-all-seat/${eventId}`,
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
      }),
    }),
    getOrderEventByCustomer: builder.query({
      query: (status) => ({
        url: "api/v2/event/orders/customer",
        params: {status},
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
      }),
    }),
    getSubscriptionsByCustomer: builder.query({
      query: () => ({
        url: `api/v2/subscriber/customer/withqr`,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
      }),
    }),
    getCustomerListSubscriberId: builder.query({
      query: ({word, listSubscriberId}) => ({
        url: `customer/byUniqueFields/${word}`,
        params: {list: listSubscriberId},
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
        responseHandler: async (response) => {
          const data = await response.json();
          return {
            ...data,
            meta: {
              status: response.status,
            },
          };
        },
      }),
    }),
    getEventTickets: builder.query({
      query: ({orderId, status}) => ({
        url: `ticket/secuencial-customer/${orderId}/${status}`,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
      }),
    }),
    getCustomerByEmail: builder.query({
      query: (email) => ({
        url: `customer/byEmail/${email}`,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
        responseHandler: async (response) => {
          const data = await response.json();
          return {
            ...data,
            meta: {
              status: response.status,
            },
          };
        },
      }),
    }),
    validatePasswordCustomer: builder.query({
      query: ({customerId, password}) => ({
        url: `customer/byId-password/${customerId}/${password}`,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
        responseHandler: async (response) => {
          const data = await response.json();
          return {
            ...data,
            meta: {
              status: response.status,
            },
          };
        },
      }),
    }),
    transferQueue: builder.mutation({
      query: (data) => ({
        url: `cola-customer`,
        method: "POST",
        body: data,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
      }),
    }),
    transferTickets: builder.mutation({
      query: (data) => ({
        url: `transaction-customer`,
        method: "POST",
        body: data,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
        responseHandler: async (response) => {
          const data = await response.json();
          return {
            ...data,
            meta: {
              status: response.status,
            },
          };
        },
      }),
    }),
    exitQueueTransferTickets: builder.mutation({
      query: (id) => ({
        url: `cola-customer/${id}`,
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
      }),
    }),
    buyQueueTickets: builder.mutation({
      query: (data) => ({
        url: `buyQueue-customer`,
        method: "POST",
        body: data,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
        responseHandler: async (response) => {
          const data = await response.json();
          return {
            ...data,
            meta: {
              status: response.status,
            },
          };
        },
      }),
    }),
    exitBuyQueueTickets: builder.mutation({
      query: ({userId, eventId}) => ({
        url: `buyQueue-remove/customer/${userId}/${eventId}/WEB`,
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
      }),
    }),
    buyDiscountQueueTickets: builder.mutation({
      query: (data) => ({
        url: `discountQueue-customer`,
        method: "POST",
        body: data,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
        responseHandler: async (response) => {
          const data = await response.json();
          return {
            ...data,
            meta: {
              status: response.status,
            },
          };
        },
      }),
    }),
    saveOrderTemporary: builder.mutation({
      query: (data) => ({
        url: `api/v2/event/order/temporary`,
        method: "POST",
        body: data,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
        responseHandler: async (response) => {
          const data = await response.json();
          return {
            ...data,
            meta: {
              status: response.status,
            },
          };
        },
      }),
    }),
    saveOrder: builder.mutation({
      query: (data: BuyOrderType) => ({
        url: `api/v2/customer/event/order`,
        method: "POST",
        body: data,
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        }),
        responseHandler: async (response) => {
          const data = await response.json();
          return {
            ...data,
            meta: {
              status: response.status,
            },
          };
        },
      }),
    }),
  }),
});

export const {
  useGetEventsQuery,
  useGetPhasesByEventMutation,
  useGetAdsByEventQuery,
  useGetZonesByLocalityQuery,
  useDeleteSeatsByLocalityMutation,
  useDeleteSeatsByEventMutation,
  useGetEventQuery,
  useGetOrderEventByCustomerQuery,
  useGetSubscriptionsByCustomerQuery,
  useLazyGetEventsQuery,
  useLazyGetCustomerListSubscriberIdQuery,
  useGetEventTicketsQuery,
  useLazyGetCustomerByEmailQuery,
  useLazyValidatePasswordCustomerQuery,
  useTransferQueueMutation,
  useTransferTicketsMutation,
  useExitQueueTransferTicketsMutation,
  useBuyQueueTicketsMutation,
  useExitBuyQueueTicketsMutation,
  useBuyDiscountQueueTicketsMutation,
  useSaveOrderTemporaryMutation,
  useSaveOrderMutation,
} = eventsApi;
